import { render } from "./AdProvider.vue?vue&type=template&id=0634d484&scoped=true"
import script from "./AdProvider.vue?vue&type=script&lang=js"
export * from "./AdProvider.vue?vue&type=script&lang=js"

import "./AdProvider.vue?vue&type=style&index=0&id=0634d484&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=1&id=0634d484&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=2&id=0634d484&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=3&id=0634d484&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=4&id=0634d484&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0634d484"],['__file',"src/views/consultant/AdProvider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0634d484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0634d484', __exports__)) {
    api.reload('0634d484', __exports__)
  }
  
  module.hot.accept("./AdProvider.vue?vue&type=template&id=0634d484&scoped=true", () => {
    api.rerender('0634d484', render)
  })

}


export default __exports__